import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateService = createAsyncThunk('updateService', async (data) => {

    var bodyFormData = new FormData();
    bodyFormData.append("maincategory_id", data?.values?.category);
    bodyFormData.append("category_id", data?.values?.sub_category);
    bodyFormData.append("id", data?.values?.id);
    bodyFormData.append("name", data?.values?.name);
    bodyFormData.append("time", (String(data?.values?.duration_hour || '0').padStart(2, '0')) + ':' + (String(data?.values?.duration_minute || '0').padStart(2, '0')));
    bodyFormData.append("description", data?.values?.description);
    bodyFormData.append("status", data?.values?.status);

    if (data?.values?.image) {
        bodyFormData.append("image", data?.values?.image);
    }

    try {
        const res = await axios({

            method: 'PUT',
            url: process.env.REACT_APP_API_URL + 'sub_category',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

